module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetHigh@2x.303f3d3.jpg";